var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: { "md-active": !!_vm.url },
      on: { "md-clicked-outside": _vm.onClose }
    },
    [
      _c("div", { staticStyle: { height: "315px", width: "560px" } }, [
        !!_vm.url
          ? _c("iframe", {
              attrs: {
                width: "560",
                height: "315",
                src: _vm.url,
                frameborder: "0",
                allow: "encrypted-media",
                allowfullscreen: ""
              }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f640f69", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f640f69","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/VideoModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6f640f69","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/VideoModal.vue
// module chunks = 1 2 3